// extracted by mini-css-extract-plugin
module.exports = {"copyright":"footer-module--copyright--3ELsL","footer":"footer-module--footer--V5wV3"};